import React from 'react'

export default function Investing() {
  return (
    <div>Investing</div>
  )
}
